export const removeItemfromArray = (array, element) => {
    const index = array.indexOf(element)
    
    if(-1 === index) {
        return array
    } else {
        array.splice(index, 1);
        return array
    }
}

export const addItemToArray = (array, element) => {
    if(array.includes(element)) {
        return array
    } else {
        return array.push(element) 
    }
}

export const reorderListItems = (list, oldIndex, newIndex) => {
    const item = list.getIn([oldIndex])

    return list.delete(oldIndex)
               .insert(newIndex, item)
}